module.exports = __webpack_public_path__ + "media/images/membership-share-f243d05e2790a246b6b304158447f8cc.jpeg";